import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/variableCosts')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/variableCost' })
  },
})
